// src/components/common/Card.js - Reusable card component
import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform var(--transition-speed) ease, 
              box-shadow var(--transition-speed) ease;
  
  ${props => props.interactive && `
    cursor: pointer;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
    }
  `}
`;

const CardImage = styled.div`
  height: ${props => props.height || '200px'};
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
`;

const CardContent = styled.div`
  padding: var(--spacing-lg);
`;

const CardTitle = styled.h3`
  margin-bottom: var(--spacing-sm);
  color: var(--text-color);
`;

const CardDescription = styled.p`
  color: var(--text-light);
  margin-bottom: var(--spacing-md);
`;

const CardFooter = styled.div`
  padding: var(--spacing-md) var(--spacing-lg);
  border-top: 1px solid var(--background-light);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Card = ({ 
  title, 
  description, 
  image, 
  imageHeight,
  footer,
  interactive = false,
  onClick,
  children,
  ...props 
}) => {
  return (
    <CardContainer 
      interactive={interactive} 
      onClick={interactive ? onClick : undefined}
      {...props}
    >
      {image && <CardImage src={image} height={imageHeight} />}
      
      <CardContent>
        {title && <CardTitle>{title}</CardTitle>}
        {description && <CardDescription>{description}</CardDescription>}
        {children}
      </CardContent>
      
      {footer && <CardFooter>{footer}</CardFooter>}
    </CardContainer>
  );
};

export default Card; 